import "../../css/home-page.scss";
import "../../css/product-cards.scss";
import { ExtractHostname } from "../Helpers/ExtractHostname";
import { WaitForElementToDisplay } from "../Helpers/WaitForElementToDisplay";

export class HomeVM {

    constructor(model) {

        let TestimonialModel = function () {
            let self = this;

            self.LeftPane = model.Testimonials.filter(function (testimonial) {
                return testimonial.HPLocTestimonial === "HP Left";
            })
            self.RightPane = model.Testimonials.filter(function (testimonial) {
                return testimonial.HPLocTestimonial === "HP Right";
            })
        }

        let SlidesModel = function () {
            let self = this;
            let data = model.Slides.sort(function (first, second) {
                let a = first.SortOrder,
                    b = second.SortOrder;
                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                } else {
                    return 0;
                }
            })

            self.SlidesXS = data.filter(function (slides) {
                return slides.DisplayXS === "Y";
            })
            self.SlidesSM = data.filter(function (slides) {
                return slides.DisplaySM === "Y";
            })
            self.SlidesMD = data.filter(function (slides) {
                return slides.DisplayMD === "Y";
            })
            self.SlidesLG = data.filter(function (slides) {
                return slides.DisplayLG === "Y";
            })
            self.SlidesXL = data.filter(function (slides) {
                return slides.DisplayXL === "Y";
            })
            self.SlidesXXL = data.filter(function (slides) {
                return slides.DisplayXXL === "Y";
            })
        }

        let TestimonialVM = new TestimonialModel();

        let SlidesVM = new SlidesModel();

        function checkExternalLink(entry) {
            let url: string = entry.TargetLink;
            if (url) {
                entry.External = true;

                let hostname: string = ExtractHostname(url);

                if (hostname.includes("life-assist.com")) {
                    entry.External = false;
                }
                return entry;
            }
        }

        if (SlidesVM.SlidesXXL.length > 0) {
            $("#slideshowXXL").find("li").first().addClass("active");
            SlidesVM.SlidesXXL.forEach(function (item, index) {
                let entry = checkExternalLink(item);
                SlidesVM.SlidesXXL.splice(index, 1, entry);
            })
        }
        else {
            if ($(window).outerWidth() >= 1400) {
                WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }
        if (SlidesVM.SlidesXL.length > 0) {
            $("#slideshowXL").find("li").first().addClass("active");
            SlidesVM.SlidesXL.forEach(function (item, index) {
                let entry = checkExternalLink(item);
                SlidesVM.SlidesXL.splice(index, 1, entry);
            })
        }
        else {
            if ($(window).outerWidth() >= 1200 && $(window).outerWidth() < 1400) {
               WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }
        if (SlidesVM.SlidesLG.length > 0) {
            $("#slideshowLG").find("li").first().addClass("active");
            SlidesVM.SlidesLG.forEach(function (item, index) {
                let entry = checkExternalLink(item);
                SlidesVM.SlidesLG.splice(index, 1, entry);
            })
        }
        else {
          if ($(window).outerWidth() >= 992 && $(window).outerWidth() < 1200) {
                WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }
        if (SlidesVM.SlidesMD.length > 0) {
            $("#slideshowMD").find("li").first().addClass("active");
            SlidesVM.SlidesMD.forEach(function (item, index) {
                let entry = checkExternalLink(item);
                SlidesVM.SlidesMD.splice(index, 1, entry);
            })
        }
        else {
            if ($(window).outerWidth() >= 768 && $(window).outerWidth() < 992) {
                WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }
        if (SlidesVM.SlidesSM.length > 0) {
            $("#slideshowSM").find("li").first().addClass("active");
            SlidesVM.SlidesSM.forEach(function (item, index) {
                let entry = checkExternalLink(item);
                SlidesVM.SlidesSM.splice(index, 1, entry);
            })
        }
        else {
            if ($(window).outerWidth() >= 576 && $(window).outerWidth() < 768) {
                WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }
        if (SlidesVM.SlidesXS.length > 0) {
            $("#slideshowXS").find("li").first().addClass("active");
            SlidesVM.SlidesXS.forEach(function (item, index) {
              let entry = checkExternalLink(item);
              SlidesVM.SlidesXS.splice(index, 1, entry);
            })
        }
        else {
            if ($(window).outerWidth() < 576) {
                WaitForElementToDisplay("#home-slideshow", 100, () => {
                    $("#home-slideshow").hide();
                });
            }
        }

        $(() => {
            // Debug
            window.vm = {};

            WaitForElementToDisplay("#home-slideshow", 800, () => {
                let slides = document.getElementById('home-slideshow')
                ko.cleanNode(slides)
                ko.applyBindings(SlidesVM, slides)
                console.info("Home slide show VM bound")
                //slides.removeAttribute('hidden')
            });
            // Debug
            window.vm.Slides = SlidesVM;

            WaitForElementToDisplay("#home-testimonials", 300, () => {
                let reviews = document.getElementById('home-testimonials')
                ko.cleanNode(reviews)
                ko.applyBindings(TestimonialVM, reviews)
                console.info("Home testimonial VM bound")
            });
            // Debug
            window.vm.Reviews = TestimonialVM;
        })

        // Pause home slider if on tablet or less
        $('#slideshowMD, #slideshowSM, #slideshowXS').carousel('pause');

        function customCarousel() {

            $('#home-slideshow').children('.carousel').each((index, slider) => {
                console.log('Carousel init');
                let slides = $(slider).find('.carousel-item');

                // Start the slides
                $('.carousel').carousel({
                    interval: 6000
                });

                $(slider).find('.prev-active').on('click', () => {
                  $(slider).carousel("prev");
                });
                $(slider).find('.prev-passive').on('click', () => {
                  $(slider).carousel("prev");
                });

                $(slider).find('.next-active').on('click', () => {
                  $(slider).carousel("next");
                });
                $(slider).find('.next-passive').on('click', () => {
                  $(slider).carousel("next");
                });

                // Override bootstrap native carousel indicator controls
                let controls = $(slider).find('.carousel-indicators').children('li');
                controls.each((index, indicator) => {
                    $(indicator).on('click', () => {

                        slides.removeClass('active');
                        controls.removeClass('active');

                        $(slides[index]).addClass('active');
                        $(indicator).addClass('active');

                        $(slider).carousel(index);

                        console.debug("Target index: ", index);
                    })
                });

                controls = $(slider).find('.carousel-indicators-new').children('li');
                controls.each((index, indicator) => {
                    $(indicator).on('click', () => {

                        slides.removeClass('active');
                        controls.removeClass('active');
                        $(slides[index]).addClass('active');
                        $(indicator).addClass('active');
                        $(slider).carousel(index);
                    })
                });

                // Set the first slide and indicator as active
                $(slider).find('.carousel-item').first().addClass('active');
                $(slider).find('.carousel-indicators').children('li').first().addClass('active');
                controls.first().addClass('active');

                $(slider).bind('slid.bs.carousel', () => {
                  // Remove active class from any other slide except the recently active slide
                    slides.each((index, item) => {
                        if ($(item).hasClass('active')) {
                          slides.not(item).removeClass('active');
                          controls.removeClass('active');
                          controls.eq(index).addClass('active');
                        }
                    })
                })
            })
        }

        $(() => {
            WaitForElementToDisplay("div[id^='slideshow'] img", 800, customCarousel);
        })

        //Handle user screen swipes
        let touchstartX = 0;
        let touchendX = 0;

        function checkDirection() {
          if (touchendX < touchstartX) {
            //Swipe left
            $('#home-slideshow').carousel("next");
          }
          else if (touchendX > touchstartX) {
            //Swipe right
            $('#home-slideshow').carousel("prev");
          }
        }

        WaitForElementToDisplay("#home-slideshow", 300, () => { 
            document.getElementById('home-slideshow').addEventListener('touchstart', handleStart);
            document.getElementById('home-slideshow').addEventListener('touchend', handleEnd);

        });
        
        function handleStart(e) {
          touchstartX = e.changedTouches[0].screenX;
        }

        function handleEnd(e) {
          touchendX = e.changedTouches[0].screenX;
          checkDirection();
        }

    }
}